import { render, staticRenderFns } from "./SetMFA.vue?vue&type=template&id=49b1e3f6"
import script from "./SetMFA.vue?vue&type=script&lang=js"
export * from "./SetMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports